module.exports = __webpack_public_path__ + "media/images/eaterprises_logo-f7d4d6d87fae5c04cbf447c1de2c4cd1.jpg";